import isEmpty from 'lodash/isEmpty'
import {parse} from 'query-string'
import * as redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/do'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/mapTo'
import * as App from '../../app'
import * as Flash from '../../components/flash-message'
import * as Form from '../../components/form'
import * as Menu from '../../components/menu'
import * as RootConstants from '../../constants'
import * as Request from '../../request'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'

export const onEnter = (
  action$: ReduxObservable.ActionsObservable<redux.Action>,
  store: redux.Store<any>,
  {history}: App.Dependencies,
) => action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname.startsWith(Menu.AUTH_RESET_PASSWORD_URL) ||
                history.location.pathname.startsWith(Menu.AUTH_ONBOARD_URL))
  .map(() => parse(history.location.search))
  .mergeMap(({username, code}) => [Actions.FormActions[Form.UPDATE]({
    name: 'username',
    value: username,
  }),
  Actions.FormActions[Form.UPDATE]({
    name: 'confirmation_code',
    value: code,
  }),
  ])

export const onEnterOnboardAuthenticated = (
  action$: ReduxObservable.ActionsObservable<redux.Action>,
  store: redux.Store<any>,
  {history, localStorage}: App.Dependencies,
) => action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname.startsWith(Menu.AUTH_ONBOARD_URL) &&
                Boolean(localStorage.getItem(RootConstants.ACCESS_TOKEN)))
  .mapTo(Router.redirect('/'))

const onFirstLoginSubmit = (
  action$: ReduxObservable.ActionsObservable<Form.SaveAction<Types.FormFields>>,
  store: redux.Store<any>,
  {history}: App.Dependencies,
) => action$.ofType(Actions.FormConstants[Form.SAVE])
  .filter(() => history.location.pathname.startsWith(Menu.AUTH_ONBOARD_URL))
  .map((action) => Actions.firstLoginSubmit(action.value))

export const onFirstLoginSuccess = (
  action$: ReduxObservable.ActionsObservable<any>,
) => action$.ofType(Request.successConstant(Constants.FIRST_LOGIN))
  .map((action) => localStorage.setItem(RootConstants.ACCESS_TOKEN, action.payload.response.access_token))
  .map(() => Router.redirect('/'))

export const onFirstLoginError = (
  action$: ReduxObservable.ActionsObservable<any>,
) => action$.ofType(Request.errorConstant(Constants.FIRST_LOGIN))
  .map((errorResponse) => Flash.showFlashError(errorResponse.payload.error.response.message))

export const alreadyConfirmedUserCheck = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: redux.Store<any>,
  {history, localStorage}: App.Dependencies,
) => action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname.startsWith(Menu.AUTH_ONBOARD_URL))
  .filter(() => !Boolean(localStorage.getItem(RootConstants.ACCESS_TOKEN)))
  .map(() => parse(history.location.search))
  .filter(({username}) => !isEmpty(username))
  .map(({username}) => Actions.checkAlreadyConfirmedUser({username}))

export const onAlreadyConfirmedUserSuccess = (
  action$: ReduxObservable.ActionsObservable<any>,
) => action$.ofType(Request.successConstant(Constants.ALREADY_CONFIRMED_USER))
  .filter((action) => action.payload.response.is_confirmed)
  .map(() => Router.redirect(Menu.AUTH_LOGIN_URL))

const onConfirmForgotPasswordSubmit = (
  action$: ReduxObservable.ActionsObservable<Form.SaveAction<Types.FormFields>>,
  store: redux.Store<any>,
  {history}: App.Dependencies,
) => action$.ofType(Actions.FormConstants[Form.SAVE])
  .filter(() => history.location.pathname.startsWith(Menu.AUTH_RESET_PASSWORD_URL))
  .map((action) => Actions.confirmForgotPasswordSubmit(action.value))

export const onConfirmForgotPasswordSuccess = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: redux.Store<any>,
  {history, localStorage}: App.Dependencies,
) => action$.ofType(Request.successConstant(Constants.CONFIRM_FORGOT_PASSWORD))
  .map((action) => localStorage.setItem(RootConstants.ACCESS_TOKEN, action.payload.response.access_token))
  .map(() => Router.redirect('/'))

export const onConfirmForgotPasswordError = (
  action$: ReduxObservable.ActionsObservable<any>,
) => action$.ofType(Request.errorConstant(Constants.CONFIRM_FORGOT_PASSWORD))
  .map((errorResponse) => Flash.showFlashError(errorResponse.payload.error.response.message))

export const epic = ReduxObservable.combineEpics(
  onAlreadyConfirmedUserSuccess,
  alreadyConfirmedUserCheck,
  onConfirmForgotPasswordError,
  onConfirmForgotPasswordSubmit,
  onConfirmForgotPasswordSuccess,
  onEnter,
  onEnterOnboardAuthenticated,
  onFirstLoginSuccess,
  onFirstLoginError,
  onFirstLoginSubmit,
)



// WEBPACK FOOTER //
// ./src/pages/reset-password/epic.ts